
export const generateCSV = (headers: Array<string>, data: Array<any>) => {
    return [
        headers,
        ...data
    ].map(row => row.map(String)
        .map(v => v.replaceAll('"', '""'))
        .map(v => `"${v}"`)
        .join(',')
    ).join('\r\n');
}

export const downloadBlob = (content, filename, contentType) => {

    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.setAttribute('download', filename);
    anchor.click();
}
